import { Settinglable } from "../models/setting"
import { API_PREFIX } from "./constant";
import { Request } from "./request";

export function getSubmitBatch(body: any): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/medicalstationconfig/submitBatch`,
    method: 'POST',
    body,
  }
}


export function geMTSSettingList(): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/medicalstationconfig/list`,
    method: 'GET',
  }
}